import ModifacePDPButton, { type ModifaceButton } from 'components/modiface/modifacePDPButton';
import styled from 'styled-components';

const StyledModifacePDPButton = styled(ModifacePDPButton)``;

const Wrapper = styled.div`
    display: flex;
    flex: 0 1 auto;
`;

export default function ModifaceButton(props: ModifaceButton) {
    const { productId, productHasVariants } = props;

    return (
        <Wrapper>
            <StyledModifacePDPButton productId={productId} productHasVariants={productHasVariants} />
        </Wrapper>
    );
}
